// Common
import { NotificationButton } from '$common/notification-button'
import { setWappRoomMute } from '$logic/wapp-room'
import { useWappRoomByWappId } from '$logic/wapp-room/react-hook'

export function WappProfileNotification({ wappId }: { wappId: string }) {
  const { entity: wappRoom } = useWappRoomByWappId(wappId)

  return (
    <NotificationButton
      muted={wappRoom?.muted}
      onClick={() => setWappRoomMute(wappRoom?.roomId || '', !wappRoom?.muted)}
    />
  )
}
